<template>
    <div class="form-page">
        <my-form v-model="form" table @submit="submitHandler">
            <my-form-item-group title="工单信息">
                <el-form-item label="主题" :rules="newRule('主题', 'required')" prop="title" class="table-full-row">
                    <el-input v-model="form.title" type="textarea" placeholder="请输入主题" maxlength="100" show-word-limit="true" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="手机" :rules="newRule('手机', 'required','mobile')" prop="phone">
                    <el-input v-model="form.phone" type="text" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" :rules="newRule('邮箱', 'required','email')" prop="email">
                    <el-input v-model="form.email" type="text" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="detail" :rules="newRule('内容', 'required')" class="table-full-row">
                    <el-input v-model="form.detail" placeholder="请输入内容" type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="选择所属项目">
                    <template slot-scope="scope">
                        <span style="max-width:300px;">{{form.zbproname||'-'}}</span>
                        <el-button icon="el-icon-search" @click="dialogVisible=true"  style="margin-left:15px;">选择</el-button>
                    </template>
                </el-form-item>
                <el-form-item label="招标项目编号" prop="zbprocode">
                    <span style="max-width:400px;">{{form.zbprocode||'-'}}</span>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload   :file-guid="fileguid|| ''"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <template slot="btn" class="btn" slot-scope="scope">
                <ca-activation icon="el-icon-circle-check" type="primary" @click="fSave(true, '1', scope.submitHandler,$event)">
                    提交（使用CA）
                </ca-activation>
                <ca-activation  icon="el-icon-remove-outline" type="warning" @click="fSave(true, '0', scope.submitHandler, $event)">
                    暂存（使用CA）
                </ca-activation>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button v-if = "identity" @click="fSave(false, '1', scope.submitHandler, $event)" type="primary" icon="el-icon-circle-check">
                    提交（不使用CA）
                </el-button>
                <el-button v-if = "identity" @click="fSave(false, '0', scope.submitHandler, $event)" type="warning" icon="el-icon-remove-outline">
                    暂存（不使用CA）
                </el-button>
            </template>
        </my-form>
        <my-dialog  title="招标项目列表" v-model="dialogVisible">
            <div>
                <zbpro @close="closedialog" @getzbpro="getzbpro"></zbpro>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import zbpro from "./form-zbxmxx";
import CaActivation from '@/components-sys/ca-activation';
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'

export default {
    mixins: [FORM_PAGE_MIXIN],
    components:{
        zbpro,
        CaActivation
    },
    data() {
        return{
            fileguid:'',
            tableData:[],
            dialogVisible:false,
            form:{
                zbproname:'',
                zbprocode:'',
                shbj:'',
                sData : "",
				sCert : "",
                cadwname : "",
                caType:'',
                fileguid:'',
                checkCA:true
            },
            dwname:'',
            caObjectVal:{},
            identity:false,
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        // 提交
        fSave:function(checkCA, shbj, cb, data){
            var that = this;

            this.form.shbj = shbj;
            that.form.caType = data
            this.form.checkCA = checkCA;
            cb();
        },

        submitHandler() {
            var that = this;
            if(this.form.fileguid==null){
                this.form.fileguid=this.fileguid
            }
            if (this.form.checkCA) {
                that.caObjectVal.character = that.form.shbj+ "$$$" + that.form.shyj + "$$$" + that.form.rows;
                //签名
                useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                    that.form.sData = res.signData;
                    //获取证书对象
                    useCA(that.form.caType, 'getCertB64', that.objectVal, function (res) {
                        that.form.sCert = res.signCert;
                        //ca单位名称
                        useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                            that.form.cadwname = res.cadwname;
                            if (that.dwname == res.cadwname) {
                                that.$post(`${that.getGetters('mngUrl')}/manage/business/xgsq/add.json`,that.form, (data, res) => {
                                    console.log(res)
                                    if (res.result) {
                                        ShowMsg(res.msg,'success')
                                        that.cancleHandler();
                                    } else {
                                        ShowMsg(res.msg)
                                    }
                                });
                            }else{
                                ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                            }
                        })
                    })
                })
            }
            else {
                that.$post(`${that.getGetters('mngUrl')}/manage/business/xgsq/add.json`,that.form, (data, res) => {
                    console.log(res)
                    if (res.result) {
                        ShowMsg(res.msg,'success')
                        that.cancleHandler();
                    } else {
                        ShowMsg(res.msg)
                    }
                });
            }
        },

        getzbpro:function(data){
            this.form.zbproname=data.zbproname;
            this.form.zbprocode=data.zbprocode;

        },
        closedialog:function(type){
            this.dialogVisible=type;
        },
        getflieguid:function(){
            var that=this
            that.$get(`${this.getGetters('mngUrl')}/manage/business/xgsq/edit.json`,{},(data, res) => {              
                that.fileguid=data.fileguid; 
                that.form.fileguid=data.fileguid;
                that.identity=data.identity;
            });
        }
    },
    created() {

    },
    mounted() {
        var that=this
        if(this.$route.query.id!=undefined){
            that.$get(`${this.getGetters('mngUrl')}/manage/business/xgsq/detail.json`,{id:this.$route.query.id}, (data, res) => {
                that.form=data.model;
                that.identity=data.identity;
                if(data.model.fileguid!=''&&data.model.fileguid!=null&&data.model.fileguid!=undefined){
                    that.fileguid=data.model.fileguid;
                }else{
                    that.getflieguid()
                }
            });
        }else{
            this.getflieguid()
        }

        that.$get(`${this.getGetters('mngUrl')}/common/getdwinfo.json`,{}, (res, data) => {
            that.dwname=data.t.dwcnname
        });


    }
}
</script>

<style scoped lang="scss">

</style>
